/*
 * @Author: 赵健
 * @Date: 2021-01-14 10:51:47
 * @LastEditTime: 2021-01-28 19:18:33
 * @LastEditors: 赵健
 * @Description: 修改描述
 * @FilePath: \trunk\src\main.js
 */
import Vue from 'vue'
import Element from 'element-ui'
import '@babel/polyfill'
import 'normalize.css/normalize.css'

// element UI 相关配置
Element.Dialog.props.closeOnClickModal.default = false // 关闭弹框点击灰色区域会关闭的问题
import './styles/element-variables.scss'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css
Vue.use(Element)
import App from './App'
import store from './store'
import router from './router'

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters
import './directive' // global directive
import components from './components' // 批量注册公共组件

Vue.use(components)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// 关闭生产环境提示
Vue.config.productionTip = false
// 全局loading
Vue.prototype.$load = () => {
  return Vue.prototype.$loading({
    lock: true,
    customClass: 'customLoading',
    background: 'rgba(0, 0, 0, 0.5)'
  })
}
// 全局格式化表格
Vue.prototype.$formatterTable = (row, column, cellValue, index) => {
  if (row === null || row === undefined || row === '') {
    return '-'
  }
  if (typeof row === 'string' || typeof row === 'number') {
    return row
  }
  if (cellValue === '' || cellValue === null || cellValue === undefined) {
    return '-'
  } else {
    return cellValue
  }
}

// 错误处理
import { errorHandle } from '@/utils'
Vue.prototype.$errorHandle = errorHandle

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
